<template>
  <div :ref="uni_id" class="monaco-editor"></div>
</template>

<script>
const MonacoSet = {};
import * as MonacoEditor from 'monaco-editor';
export default {
  name: 'MonacoEditor',
  props: {
    uni_id: {
      type: String,
      required: true,
    },
    minimap: {
      type: Boolean,
      default: true,
    },
    language: {
      type: String,
      default: 'javascript',
    },
    codeData: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myMonacoEditor: {},
      startTime: '',
    };
  },
  watch: {
    codeData: {
      deep: true,
      handler: function(newValue) {
        console.log('--------codeData--------------');
        console.log(newValue);
        // 更新编辑器的内容
        MonacoSet[this.uni_id].setValue(newValue);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initMonaco();
    });
  },
  beforeUnmount() {
    console.log('beforeUnmount');
    console.log(MonacoSet[this.uni_id].dispose);
    MonacoSet[this.uni_id].dispose();
  },
  methods: {
    // 初始化编辑器Monaco实例
    initMonaco() {
      // Since packaging is done by you, you need
      // to instruct the editor how you named the
      // bundles that contain the web workers.

      MonacoSet[this.uni_id] = MonacoEditor.editor.create(this.$refs[this.uni_id], {
        value: this.codeData,
        theme: 'vs-dark',
        language: this.language,
        // readOnly: this.readOnly,
        minimap: {
          enabled: this.minimap,
        },
      });
      // 监听MonacoEditor内容是否更改
      MonacoSet[this.uni_id].onDidChangeModelContent(() => {
        this.$emit('change', MonacoSet[this.uni_id]);
        // 解除只读（只读状态无法格式化代码）

        if (this.readOnly === true) {
          MonacoSet[this.uni_id].updateOptions({ readOnly: false });
          MonacoSet[this.uni_id].trigger('anyString', 'editor.action.formatDocument');

          // 格式化代码
          // 监听格式化代码完成
          MonacoSet[this.uni_id]
            .getAction('editor.action.formatDocument')
            .run()
            .then(() => {
              // console.log('formatDocument finished');
              // 判断是否为只读
              if (this.readOnly === true) {
                // 开启只读
                MonacoSet[this.uni_id].updateOptions({ readOnly: true });
              }
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.monaco-editor {
  width: 100%;
  height: 100%;
}
</style>
